import { ResetPasswordSection } from "@/design-system/Organisms";

export const ResetPasswordTemplate = () => {
    return (
        <>
            <ResetPasswordSection />
        </>
    );
};

export default ResetPasswordTemplate;
